export interface TaxCodeClass {
    AccountTaxCodeId: number
    AccountId: number
    TaxCode: string
    Formula: string
    AccountTaxZoneId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}

export const taxcodeInitialsForApp = {
    TaxCode: "",
    Formula: "",
    AccountTaxZoneId: 0,
    IsDisabled:false
}

export const taxcodeInitialsForUpdate = {
    TaxCode: "",
    Formula: "",
    AccountTaxCodeId: 0,
    IsDisabled:false
}